<template>
  <svg
    width="49"
    height="48"
    viewBox="0 0 49 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_22521_84989)">
      <path
        d="M12.9511 44.6692C12.4397 44.6692 11.9493 44.466 11.5876 44.1044C11.226 43.7428 11.0229 43.2523 11.0229 42.7409L11.0036 16.6278C10.9803 16.0539 11.0708 15.481 11.2698 14.9421C11.4688 14.4033 11.7723 13.9091 12.163 13.4879C12.5537 13.0668 13.0237 12.7271 13.5462 12.4883C14.0686 12.2494 14.6331 12.1163 15.2072 12.0964L33.6993 12C34.2741 12.01 34.8414 12.1332 35.3686 12.3625C35.8958 12.5918 36.3727 12.9227 36.772 13.3364C37.1713 13.75 37.4852 14.2383 37.6958 14.7733C37.9064 15.3082 38.0095 15.8795 37.9993 16.4543L37.9993 42.5674C38.0026 42.9053 37.9171 43.2381 37.7513 43.5325C37.5854 43.827 37.3452 44.0726 37.0545 44.245C36.7613 44.4142 36.4288 44.5033 36.0903 44.5033C35.7519 44.5033 35.4193 44.4142 35.1262 44.245L24.1351 38.1516L13.9346 44.3799C13.6325 44.5487 13.2964 44.6475 12.9511 44.6692Z"
        fill="#F08B71"
      />
      <rect
        x="43.5137"
        y="3.21289"
        width="3"
        height="6"
        rx="1.5"
        transform="rotate(45 43.5137 3.21289)"
        fill="#F08B71"
      />
      <rect
        x="35.5845"
        y="0.233398"
        width="3"
        height="6"
        rx="1.5"
        transform="rotate(15 35.5845 0.233398)"
        fill="#F08B71"
      />
      <rect
        x="47.8379"
        y="10.3657"
        width="3"
        height="6"
        rx="1.5"
        transform="rotate(75 47.8379 10.3657)"
        fill="#F08B71"
      />
    </g>
    <defs>
      <clipPath id="clip0_22521_84989">
        <rect
          width="48"
          height="48"
          fill="white"
          transform="translate(0.5 -0.000488281)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
